import { render, staticRenderFns } from "./SectionFormContenu.vue?vue&type=template&id=1c45fe12&scoped=true&"
import script from "./SectionFormContenu.vue?vue&type=script&lang=js&"
export * from "./SectionFormContenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c45fe12",
  null
  
)

export default component.exports